import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./AuthLayout.scss";

export default function AuthLayout(props) {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  const handleSidebarMouseEnter = () => {
    if (typeof window !== "undefined" && window.innerWidth > 1200 && !sidebarToggle) {
      setIsSidebarHovered(true);
    }
  };

  const handleSidebarMouseLeave = () => {
    if (typeof window !== "undefined" && window.innerWidth > 1200) {
      setIsSidebarHovered(false);
    }
  };

  const isSidebarOpen = sidebarToggle || isSidebarHovered;

  return (
    <div className="layout-main">
      <div
        className={
          isSidebarOpen
            ? "sidebar-content"
            : "sidebar-content sidebar-content-hidden"
        }
        onMouseEnter={handleSidebarMouseEnter}
        onMouseLeave={handleSidebarMouseLeave}
      >
        <Sidebar setSidebarToggle={setSidebarToggle} />
      </div>
      <div
        className="header-and-content"
        onClick={() => {
          if (sidebarToggle) {
            setSidebarToggle(false);
          }
          setIsSidebarHovered(false);
        }}
      >
        <Header Header setSidebarToggle={setSidebarToggle} />
        <div className="content-main">{props.children}</div>
      </div>
    </div>
  );
}
